import React from 'react';
import { useSelector } from 'react-redux';
import SuppliersComponent from '../../Supplier/SupplierComponent/SuppliersComponent';

function Factories({ querySupplierId }) {
  const selector = useSelector((state) => state);
  const {
    UserDetails: { userInfo },
  } = selector;

  const userId = userInfo?.userId || querySupplierId;
  return <SuppliersComponent supplierId={userId} />;
}

export default Factories;
